import React from 'react';
import { SubmitError } from 'Components/Fields/SubmitError';
import { SubmitButton } from 'Components/Fields/Buttons';
import { normalizeUpperCase } from 'Utils/FormNormalizers';
import { required } from 'Utils/FormValidation';
import { useForm } from 'Hooks/useForm';
import { FormField } from 'Components/HookFormFields/FormField';
import './RedeemGiftCardForm.css';

const RedeemGiftCardForm = ({ onFormSubmit, onChangeGiftCode, isDisabled = false }) => {
  const formName = 'redeemGiftCardForm';

  const { formFieldProps, submitting, formError, submitStatus, handleSubmit } = useForm({
    onFormSubmit,
    formName,
  });
  const submitSucceeded = submitStatus === 'success';

  return (
    <form
      onSubmit={(event) => handleSubmit(event)}
      className={`redeemGiftCardForm ${submitSucceeded ? 'submitSucceeded' : ''}`}
    >
      <h2 className="title">Enter your gift code to redeem.</h2>
      <div className="pinEntry">
        <FormField
          className="pinInput"
          name="giftCode"
          label="Gift Code"
          component="InputField"
          validate={[required]}
          normalize={normalizeUpperCase}
          optionalSuccessMark
          onChange={onChangeGiftCode}
          isDisabled={isDisabled}
          {...formFieldProps}
        />
        <SubmitButton isDisabled={isDisabled} submitting={submitting} className="applyBtn" text="Apply" />
      </div>
      <div className="pinErrorMsg">
        <SubmitError error={formError} formName={formName} />
      </div>
    </form>
  );
};

export default RedeemGiftCardForm;
